export enum SigningAgentDesignation {
  TeamSigningAgent = 'TeamSigningAgent',
  PreferredAgent = 'PreferredAgent'
}

export const SIGNING_AGENT_DESIGNATION_LABELS: Readonly<Record<SigningAgentDesignation, string>> = {
  [SigningAgentDesignation.TeamSigningAgent]: 'Team Signing Agent',
  [SigningAgentDesignation.PreferredAgent]: 'Preferred Agent',
};
